import React, { ReactNode, useState } from 'react';
import { Collapse, Grid, IconButton, Typography } from '@mui/material';
import { ArrowForwardIosRounded } from '@mui/icons-material';

interface ICollapsibleContent {
  children: ReactNode;
  header: string;
}

const CollapsibleContent: React.FC<ICollapsibleContent> = ({ children, header }) => {
  const [mfmCollapsed, setMfmCollapsed] = useState(true);
  const onCollapseClick = () => setMfmCollapsed(!mfmCollapsed);
  return (
    <>
      <Grid container>
        <Grid item>
          <IconButton
            size="small"
            onClick={onCollapseClick}
            sx={{ width: 32, height: 32, p: 1 }}
            data-testid="collapse-button"
          >
              <ArrowForwardIosRounded
                sx={(theme) => ({
                  color: mfmCollapsed ? theme.palette.primary.main : '',
                  transform: `rotate(${mfmCollapsed ? '90' : '0'}deg)`,
                  transition: 'all 100ms ease-in-out',
                  fontSize: 18
                })}
              />
          </IconButton>
        </Grid>
      <Grid item>
      <Typography
        sx={{
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '28px',
          font: 'Noto Sans',
          margin: '0',
        }}
      >
        {header}
      </Typography>
      </Grid>
    </Grid>
        <Collapse in={mfmCollapsed} sx={{ pl: 4 }}>
        { children }
    </Collapse>
    </>
  );
};

export default CollapsibleContent;